import { SearchBarFiltersProps } from "../../constants/constants";

import { BuildingTypeFilter } from "./building-type-filter";
import { MarketAreaFilter } from "./market-area-filter";
import { PriceRangeFilter } from "./price-range-filter";
import { ProjectStatusFilter } from "./project-status-filter";
import { PropertyTransactionTypeFilter } from "./property-transaction-type-filter";

export const SearchBarFilters = ({
  filters,
  mainColor,
  mainColorLight,
  textColor,
  setFilters,
  goToFirstPage,
}: SearchBarFiltersProps) => {
  return (
    <>
      <PropertyTransactionTypeFilter
        filters={filters}
        mainColor={mainColor}
        mainColorLight={mainColorLight}
        textColor={textColor}
        setFilters={setFilters}
        goToFirstPage={goToFirstPage}
      />
      <PriceRangeFilter
        filters={filters}
        mainColor={mainColor}
        mainColorLight={mainColorLight}
        textColor={textColor}
        setFilters={setFilters}
        goToFirstPage={goToFirstPage}
      />
      <MarketAreaFilter
        filters={filters}
        mainColor={mainColor}
        mainColorLight={mainColorLight}
        textColor={textColor}
        setFilters={setFilters}
        goToFirstPage={goToFirstPage}
      />
      <BuildingTypeFilter
        filters={filters}
        mainColor={mainColor}
        mainColorLight={mainColorLight}
        textColor={textColor}
        setFilters={setFilters}
        goToFirstPage={goToFirstPage}
      />
      <ProjectStatusFilter
        filters={filters}
        mainColor={mainColor}
        mainColorLight={mainColorLight}
        textColor={textColor}
        setFilters={setFilters}
        goToFirstPage={goToFirstPage}
      />
    </>
  );
};
